export const SEASON_OPTIONS = [
  { label: "Season 13-2", value: 21 },
  { label: "Season 13-1", value: 20 },
  { label: "Preseason 13", value: 19 },
  { label: "Season 12", value: 18 },
  { label: "Preseason 12", value: 17 },
  { label: "Season 11", value: 16 },
  { label: "Preseason 11", value: 15 },
];
